import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { View } from '@dbk/ui-react-utils'
import { StyleSheet } from 'react-native'
import Text, {Large} from '@dbk/ui-text'
import { createContainer } from '@dbk-legacy/muster/react'
import { NavigationListItem } from '@dbk/ui-list'
import ReportCategoryListItem from './report-category-list-item'
import ReportPreview from '../report-preview'
import download from '../../../../../../src/muster/utils/downloader'
import { SUCCESS_RESPONSE_CODE, SELECTED_RANGE } from '../constants'
import { LoadingCircle } from '../../../../../../src/components/common/loading'
import { getDocumentName } from '../../../../../../src/components/common/reports-name-conventions/reports-name-conventions'
import additionalStyles from './report-category.styles'

const pdfData =
  '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'

class ReportCategoryDocListItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      documentId: null,
      docName: null,
      pdfByteStream: '',
      downloadInProgress: false,
      extType: '',
      documentType: '',
      documentObj: '',
    }
  }
  closePdf = () => {
    this.setState({ documentId: null })
  }

  closeBlurModel = () => {
    if (this.state.documentId != null) {
      return
    }
    this.setState({
      modalVisible: false,
      docName: null,
      documentId: null,
      pdfByteStream: '',
      extType: '',
      documentType: '',
    })
    // this.props.resetDocumentData() // WMCE-43945 document list gets to default list after closing the preview popoup
    this.props.getDocuments(); // WMCE-46390-To update status of badge upon clicking Preview
  }

  onItemClicked = document => {
    this.setState({
      modalVisible: true,
      documentId: document.documentId,
      docName: document.documentName,
      pdfByteStream: '',
      extType: '',
      documentType: '',
      documentObj: document,
    })
    // this.props.downloadDocuments(document.documentId);
    this.downloader(document.documentId)
  }

  /* WMCE-3303, WMCE-3068 documentDownloadDisabled flag added to disable download capability for RM Login on Behalf */
  downloader = documentId => {
    // 16560003 csv
    // 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003
    // const filesToDownload = [13674003]; // 13678003, 13681003, 13687003, 13693003, 13696003, 13679003, 13680003, 13683003, 13689003, 13690003, 13697003, 13675003, 13676003];
    const {
      settings: {
        currentEnvironment: { remoteUrl },
      },
      auth: { userId, authHeader, langCode, documentDownloadDisabled },
      i18n: { messages },
    } = this.props

    this.setState({ downloadInProgress: true })

    const RSA_URL =
      remoteUrl + '/edelivery/' + this.props.app.config.apiverion + '/downloadDocumentsInBinary'

    const body = {
      userId: userId,
      branchCode: this.props.app.user.selectedPortfolio.branchCode,
      channel: 'WEB',
      language: langCode,
      documentIds: [documentId],
    }
    const documentName = ''
    const that = this

    const x = new XMLHttpRequest()
    x.open('POST', RSA_URL, true)
    x.setRequestHeader('Authorization-Token', authHeader)
    x.setRequestHeader('content-type', 'application/json')
    x.setRequestHeader('Accept', 'application/octet-stream')
    // x.setRequestHeader('Authorization', 'Bearer 7b6985ad2ab73fa260b495f4b462d63a');
    x.setRequestHeader('Content-Disposition', 'inline; filename=' + documentName)
    x.setRequestHeader('Cache-Control', 'no-cache, no-store, must-revalidate')
    x.setRequestHeader('Pragma', 'no-cache')
    x.setRequestHeader('Expires', '0')
    x.responseType = 'arraybuffer'
    x.timeout = 300000
    x.ontimeout = function() {
      that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage'])
    }

    x.onload = function(e) {
      if (x.status === SUCCESS_RESPONSE_CODE) {
        const documentType = x.getResponseHeader('content-type')
        // const ext = documentType.split('/');
        let ext = ''
        if (documentType.includes('/pdf')) {
          ext = '.pdf'
        } else {
          ext = '.' + documentType.split(';')[0].split('/')[1]
        }

        if (!that.state.modalVisible) {
          return
        }

        if (that.detectIE()) {
          if (!documentDownloadDisabled) {
            download(x.response, getDocumentName(that.state.documentObj) + ext, documentType) // text/csv and

            if (that.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
              that.props.getCustomRangeDocuments(
                that.props.reports.startDate,
                that.props.reports.endDate
              )
            } else {
              that.props.getDocuments()
            }
            that.setState({
              modalVisible: false,
              docName: null,
              documentId: null,
              pdfByteStream: '',
              extType: '',
              documentType: '',
              downloadInProgress: false,
            })
            return
          } else {
            that.setState({
              modalVisible: false,
              docName: null,
              documentId: null,
              pdfByteStream: '',
              extType: '',
              documentType: '',
              downloadInProgress: false,
            })
            that.props.setBlurModalError(messages['app.rmAccess.genericError'])
            return
          }
        }

        if (ext !== '.pdf') {
          if (!documentDownloadDisabled) {
            // that.setState({ pdfByteStream: x.response, extType: ext, documentType, errorHeader: messages['app.chedelivery.reports.unsupportedTypeHeader'], downloadInProgress: false });
            download(x.response, that.state.docName + ext, documentType) // text/csv and
            if (that.props.reports.selectedReportDetailsDateRange === SELECTED_RANGE.CUSTOM) {
              that.props.getCustomRangeDocuments(
                that.props.reports.startDate,
                that.props.reports.endDate
              )
            } else {
              that.props.getDocuments()
            }
            that.setState({
              modalVisible: false,
              docName: null,
              documentId: null,
              pdfByteStream: '',
              extType: '',
              documentType: '',
              downloadInProgress: false,
            })
          } else {
            that.setState({
              modalVisible: false,
              docName: null,
              documentId: null,
              pdfByteStream: '',
              extType: '',
              documentType: '',
              downloadInProgress: false,
            })
            that.props.setBlurModalError(messages['app.rmAccess.genericError'])
          }
        } else
          that.setState({
            pdfByteStream: x.response,
            extType: ext,
            documentType,
            downloadInProgress: false,
          })
        // that.props.getDocuments();
      } else {
        that.setState({
          modalVisible: false,
          docName: null,
          documentId: null,
          pdfByteStream: '',
          extType: '',
          documentType: '',
          downloadInProgress: false,
        })
        that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage'])
      }
    }
    x.send(JSON.stringify(body))
    x.onerror = function(e) {
      that.setState({
        modalVisible: false,
        docName: null,
        documentId: null,
        pdfByteStream: '',
        extType: '',
        documentType: '',
        downloadInProgress: false,
      })
      that.props.setBlurModalError(messages['app.chedelivery.reports.systemErrorMessage'])
    }
  }

  detectIE = () => {
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('MSIE ') // IE 10 or older => return version number
    const trident = ua.indexOf('Trident/') // IE 11 => return version number
    const edge = ua.indexOf('Edge/') // IE 12 => return version number
    if (msie > 0 || trident > 0 || edge > 0) {
      return true
    }
    return false
  }

  // method to render report row
  renderReportRow = dataForRendering => {
    const lastRowLen = dataForRendering.length
    const {
      i18n: { messages },
    } = this.props
  

    return (
      <React.Fragment>
        {dataForRendering.map((item, i) => {
          if (i === lastRowLen - 1) {
            this.props.setIsScrollLoading(false)
          }
          return (
            <NavigationListItem inverse selected hasArrow={false} className="ReportDocListItems">
              <ReportCategoryListItem
                item={item}
                showPdf
                showDate
                isChecked={item.checked}
                handleReportItemClick={() => this.props.handleReportItemClick(item)}
                handlePreviewClick={() => this.onItemClicked(item)}
                downloadIndividualReport={this.props.downloadIndividualReport}

              />
            </NavigationListItem>
          )
        })}
      </React.Fragment>
    )
  }

  render() {
    const {
      i18n: { messages },
      screen,
      reports: { isScrollLoading },
      categoryReportList,
    } = this.props
    return (
      <View>
        {this.renderReportRow(categoryReportList)}
        {isScrollLoading && <LoadingCircle />}
        <ReportPreview
          screen={screen}
          modalVisible={this.state.modalVisible}
          doneLabel="Done"
          onCloseBlurModel={() => this.closeBlurModel()}
          headerLabel={this.state.docName}
          documentName={this.state.documentObj}
          closePdf={this.closePdf}
          pdfData={this.state.pdfByteStream}
          messages={messages}
          pdfDataDownloadInProgress={this.state.downloadInProgress}
          extType={this.state.extType}
          documentType={this.state.documentType}
          documentDownloadDisabled={this.props.auth.documentDownloadDisabled}
        />
      </View>
    )
  }
}

ReportCategoryDocListItem.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
}

ReportCategoryDocListItem.defaultProps = {
  i18n: {},
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    setBlurModalError: {
      $call: 'reports.setBlurModalError',
    },
    app: {
      config: {
        apiverion: true,
      },
      user: {
        selectedPortfolio: true,
      },
    },
    settings: {
      currentEnvironment: {
        remoteUrl: true,
      },
    },
    auth: {
      userId: true,
      authHeader: true,
      langCode: true,
      documentDownloadDisabled: true,
    },
    getDocuments: {
      $call: 'reports.getDocuments',
    },
    downloadDocuments: {
      $call: 'reports.downloadDocuments',
    },
    resetDocumentData: {
      $call: 'reports.resetDocumentData',
    },
    setIsScrollLoading: {
      $set: 'reports.isScrollLoading',
    },
    getCustomRangeDocuments: {
      $call: 'reports.fetchDocumentsForCategories',
    },
    reports: {
      selectedReportDetailsDateRange: true,
      pdfBinaryData: true,
      setPdfBinaryData: {
        $set: 'pdfBinaryData',
      },
      pdfDataDownloadInProgress: true,
      isScrollLoading: true,
      startDate: true,
      endDate: true,
    },
    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
  },
})(ReportCategoryDocListItem)
